import apiClient from '../utils/axiosConfig.ts';
import { CustomerOrder } from '../types';

const customerOrderService = {
  getCustomerOrders: async (params?: {
    skip?: number;
    limit?: number;
    customer_id?: number;
    order_status_id?: number;
  }): Promise<CustomerOrder[]> => {
    const response = await apiClient.get('/customer-orders/', { params });
    return response.data;
  },

  getCustomerOrder: async (id: number): Promise<CustomerOrder> => {
    const response = await apiClient.get(`/customer-orders/${id}`);
    return response.data;
  },

  createCustomerOrder: async (data: any): Promise<CustomerOrder> => {
    const response = await apiClient.post('/customer-orders/', data);
    return response.data;
  },

  updateCustomerOrder: async (id: number, data: any): Promise<CustomerOrder> => {
    const response = await apiClient.put(`/customer-orders/${id}`, data);
    return response.data;
  },

  deleteCustomerOrder: async (id: number): Promise<void> => {
    await apiClient.delete(`/customer-orders/${id}`);
  },

  convertToSupplierOrders: async (orderId: number) => {
    const response = await apiClient.post(`/customer-orders/${orderId}/convert-to-supplier-orders`);
    return response.data;
  },

  getAvailableSuppliers: async (orderId: number, productId: number) => {
    const response = await apiClient.get(`/customer-orders/${orderId}/available-suppliers/${productId}`);
    return response.data;
  },

  associateSuppliersAndConvert: async (orderId: number, associations: Array<{
    product_id: number;
    supplier_id: number;
    cost?: number;
    lead_time_days?: number;
    minimum_order_quantity?: number;
    is_primary: boolean;
  }>) => {
    const response = await apiClient.post(`/customer-orders/${orderId}/associate-suppliers-and-convert`, {
      associations
    });
    return response.data;
  }
};

export default customerOrderService;
